import React from "react";
import MutedInSpace from "graphics/icons/SpacePeople/MutedInSpace";
import NotShoutableInSpace from "graphics/icons/SpacePeople/NotShoutableInSpace";
import MutedForMeInSpace from "graphics/icons/SpacePeople/MutedForMeInSpace";
import LockedInSpace from "graphics/icons/SpacePeople/LockedInSpace";

const PersonStateGraphics = ({ peopleMedia, user_id }) => {
  let luid = null;
  for (var i in peopleMedia) {
    if (peopleMedia[i].uuid === user_id) luid = i;
  }

  if (
    peopleMedia[luid] === undefined ||
    (!peopleMedia[luid].muted &&
      !peopleMedia[luid].mutedForMe &&
      peopleMedia[luid].shoutable &&
      !peopleMedia[luid].locked)
  ) {
    return null;
  }
  return (
    <div className="Txt-member-info">
      {peopleMedia[luid].muted ? <MutedInSpace /> : null}
      {peopleMedia[luid].mutedForMe ? <MutedForMeInSpace /> : null}
      {!peopleMedia[luid].shoutable ? <NotShoutableInSpace /> : null}
      {peopleMedia[luid].locked ? <LockedInSpace /> : null}
    </div>
  );
};

export default PersonStateGraphics;
